import { render, staticRenderFns } from "./FileDownloadCreator.vue?vue&type=template&id=2db4faee"
import script from "./FileDownloadCreator.vue?vue&type=script&lang=js"
export * from "./FileDownloadCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports